export const ERROR_BOUNDARY_TEXT = {
    TITLE: "Something went wrong",
    BODY: "An unexpected error occurred. Our team has been notified.",
    REF_PREFIX: "Ref:",
    BUTTONS: {
        RETRY: "Try Again",
        DASHBOARD: "Go to Dashboard",
    },
} as const;
